import { makeStyles } from '@mui/styles';
import { Grid, Typography, Divider, Link } from '@mui/material';
import { memo } from 'react';

const Dashboard = () => {
  return <div>Main Dashboard</div>;
};
export default Dashboard;
